import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link as MuiLink, Typography } from '@mui/material';
import LegalLayout from './LegalLayout';

function ConfidentialitePage() {
  return (
    <LegalLayout title="Politique de confidentialité">
      <Typography variant="body2" sx={{ color: '#888', mb: 2 }}>
        Dernière mise à jour : octobre 2026
      </Typography>

      <p>
        La présente politique décrit comment <strong>baoubab</strong>, édité par{' '}
        <strong>Bokonzi</strong> (Abidjan), collecte et utilise vos données personnelles
        lorsque vous utilisez l&apos;application mobile ou le site{' '}
        <MuiLink href="https://baoubab.space">baoubab.space</MuiLink>.
      </p>

      <h2>1. Responsable du traitement</h2>
      <p>
        Bokonzi — contact :{' '}
        <MuiLink href="mailto:bokonzibaoubab@gmail.com">bokonzibaoubab@gmail.com</MuiLink>
      </p>

      <h2>2. Données collectées</h2>
      <ul>
        <li>
          <strong>Parent / tuteur :</strong> adresse e-mail, nom, type de profil
          (parent ou enseignant), numéro de téléphone (facultatif).
        </li>
        <li>
          <strong>Enfant :</strong> prénom, nom, tranche d&apos;âge, réponses aux
          questionnaires, profil pédagogique et, le cas échéant, résultat du parcours
          neuroatypique (orientation pédagogique, non diagnostique).
        </li>
        <li>
          <strong>Commandes :</strong> produits, quantités, montants, statut, coordonnées
          de livraison si fournies.
        </li>
        <li>
          <strong>Données techniques (app) :</strong> statistiques d&apos;utilisation,
          rapports de plantage, jeton de notification, identifiant publicitaire (mesure
          d&apos;audience uniquement), via les services Firebase le cas échéant.
        </li>
      </ul>

      <h2>3. Finalités</h2>
      <ul>
        <li>Créer et gérer votre compte (authentification par code OTP e-mail).</li>
        <li>Personnaliser les contenus et activités pour chaque enfant.</li>
        <li>Traiter les commandes et l&apos;accompagnement pédagogique.</li>
        <li>Améliorer la qualité et la sécurité du service.</li>
        <li>Répondre à vos demandes via le{' '}
          <MuiLink component={RouterLink} to="/contact">formulaire de contact</MuiLink>.
        </li>
      </ul>

      <h2>4. Base légale</h2>
      <p>
        Traitement fondé sur l&apos;exécution du contrat (fourniture du service), votre
        consentement (notifications, certains traitements optionnels) et, le cas échéant,
        nos intérêts légitimes (sécurité, amélioration du produit), dans le respect des
        droits des mineurs.
      </p>

      <h2>5. Partage des données</h2>
      <p>
        Nous ne vendons pas vos données. Elles peuvent être traitées par des prestataires
        techniques nécessaires au service (hébergement, envoi d&apos;e-mails OTP, Firebase
        pour l&apos;app mobile). Aucun diagnostic médical n&apos;est établi ni partagé.
      </p>

      <h2>6. Conservation</h2>
      <p>
        Les données de compte sont conservées tant que le compte est actif. Après une
        demande de suppression, nous nous engageons à supprimer les données personnelles
        dans un délai de <strong>30 jours</strong>, sous réserve des obligations légales
        de conservation (ex. pièces comptables liées à une commande payée).
      </p>

      <h2>7. Sécurité</h2>
      <p>
        Les échanges avec l&apos;API se font en HTTPS (
        <code>https://api.baoubab.space</code>). Les codes OTP sont stockés de façon
        hachée et à durée limitée.
      </p>

      <h2>8. Vos droits</h2>
      <p>
        Vous pouvez demander l&apos;accès, la rectification ou la suppression de vos
        données via la page{' '}
        <MuiLink component={RouterLink} to="/suppression-compte">Suppression de compte</MuiLink>
        {' '}ou en nous écrivant à{' '}
        <MuiLink href="mailto:bokonzibaoubab@gmail.com">bokonzibaoubab@gmail.com</MuiLink>.
      </p>

      <h2>9. Documents liés</h2>
      <p>
        <MuiLink component={RouterLink} to="/conditions">Conditions d&apos;utilisation</MuiLink>
        {' · '}
        <MuiLink component={RouterLink} to="/contact">Contact</MuiLink>
      </p>
    </LegalLayout>
  );
}

export default ConfidentialitePage;
